"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticatorHOC = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var aws_amplify_1 = require("aws-amplify");
var ui_react_1 = require("@aws-amplify/ui-react");
var login_style_1 = require("./login-style");
/**
 * Higher order component used to wrap the app in access control.
 *
 * This will cause the app to be behind a login screen.
 *
 * @example
 * ```
 * import { AuthenticatorHOC } from "gsf-util-react-auth";
 * import App from "./path/to/app";
 *
 * const AuthenticatedApp = AuthenticatorHOC(App);
 *
 * ReactDOM.render(
 *  <AuthenticatedApp />,
 *  document.getElementById("root")
 * )
 * ```
 */
var AuthenticatorHOC = function (WrappedComponent) {
    return function (props) {
        react_1.default.useEffect(function () {
            // TEST IF USER LOGGED IN
            aws_amplify_1.Auth.currentAuthenticatedUser().then(function (user) {
                console.log('User is authenticated', user);
            }).catch(function (err) {
                console.log('User is not authenticated', err);
                aws_amplify_1.Auth.federatedSignIn(); // FORCE LOG IN WHICH USES HOSTED UI
            });
        }, []);
        return ((0, jsx_runtime_1.jsx)(ui_react_1.Authenticator, __assign({ signUpAttributes: ['email'], components: login_style_1.amplifyConfig, className: "blue" }, { children: function (_a) {
                var signOut = _a.signOut, user = _a.user;
                return ((0, jsx_runtime_1.jsx)(WrappedComponent, __assign({ signOut: signOut, user: user }, props)));
            } })));
    };
};
exports.AuthenticatorHOC = AuthenticatorHOC;
